import { Component, OnInit, OnDestroy, OnChanges, Input } from '@angular/core';
import { DadosContratosModel } from './../model/dados-contrato.model';
import Utils from '../utils/utils';
import { DadosTermoRevogacaoPerfilMock } from '../mock/termo-revogacao-registro-mock';

@Component({
  selector: 'app-renova-contrato-amplo-pj',
  templateUrl: './renova-contrato-amplo-pj.component.html',
  styleUrls: ['./renova-contrato-amplo-pj.component.css']
})
export class RenovaContratoAmploPjComponent implements OnInit {

  @Input() infoContratos: DadosContratosModel;
  public inscricaoFormatada: string;
  public termoRevogacaoStr: String;

  ngOnInit(){
 //   this.formatarInscricao();
   this.formataMascaraInscricao();
    this.termoRevogacaoStr = new DadosTermoRevogacaoPerfilMock().textoTermoRevogacaoJuridico(this.infoContratos) ;
  }


  public formatarInscricao() {

    const tipoInsc = this.infoContratos.tipoInscricao;
    this.inscricaoFormatada = Utils.formatarInscricao(this.infoContratos.inscricao, tipoInsc);
    switch (tipoInsc) {
      case '3':
        this.inscricaoFormatada = Utils.mascararCPF(this.inscricaoFormatada);
        break;
      case '2':
        this.inscricaoFormatada = Utils.mascararCEI(this.inscricaoFormatada);
    }
  }

  public formataMascaraInscricao(){
    const tipoInsc = this.infoContratos.tipoInscricao;
    this.inscricaoFormatada = Utils.mascararInscricao(tipoInsc, this.infoContratos.inscricao);
  }

}
